// extracted by mini-css-extract-plugin
module.exports = {"root":"_3d8952","answer":"_038cdb"};